<template>
    <div class="edit-detail layout-sub-page">
        <div class="title-bar dsp-flex">
            <div class="title-side title-gray">
                <i class="iconfont icon-xiangzuo" @click="clickBack"></i>
            </div>
            <div class="title-middle">编辑</div>
            <div class="title-side title-right" @click="clickSave">
                <button class="title-button" v-bind:class="{'title-button-gray': !editedStatus}" v-bind:disabled="!editedStatus">保存</button>
            </div>
        </div>
        <div class="detail-content edit-detail-content">
            <!-- 1. 命盘部分 -->
            <fate-panel 
                v-bind:hideSideBar="true" 
                v-bind:fateData="editFateListData" 
                v-bind:fateInfo="editFateInfo">
            </fate-panel>

            <!-- 2. 编辑修改部分 -->
            <div class="edit-detail-form width90p">
                <collate-form 
                    v-bind:parentNode="parentNode" 
                    v-bind:chooseGroupFunc="clickChooseGroup" 
                    v-bind:personData="editPersonInfo"
                    v-bind:chooseLabelFunc="clickChooseLabel">
                </collate-form>
            </div>
        </div>
        <!-- 3. 选择地址组件 -->
        <van-overlay v-show="showArea" @click="clickShowAreaOverlay" />
        <vant-area v-show="showArea" v-bind:parentNode="parentNode"></vant-area>

        <!-- 4. 输入生日日期组件 -->
        <van-popup v-bind:value="showBirthday" position="bottom" @click-overlay="clickShowBirthdayOverlay">
            <input-birthday-panel
                v-bind:parentNode="parentNode">
            </input-birthday-panel>
        </van-popup>

        <router-view></router-view>
    </div>
</template>
<script>
import FatePanel from '../../layouts/panel/FatePanel.vue'
import CollateForm from '../../layouts/collate/CollateForm.vue'
import VantArea from '../../layouts/vant/VantArea.vue'
import InputBirthdayPanel from '../../components/InputBirthdayPanel.vue'
import { CONFIG } from '../../modules/config'

export default {
    name: 'EditDetail',
    components: { FatePanel, CollateForm, VantArea, InputBirthdayPanel},
    computed: {
        showArea () {
            return this.$store.state.collate.showArea;
        },
        showBirthday() {
            return this.$store.state.collate.showBirthday;
        },
        editPersonInfo() {
            return this.$store.state.edit.editPersonInfo;
        },
        editFateInfo() {
            return this.$store.state.edit.editFateInfo;
        },
        editFateListData() {
            return this.$store.state.edit.editFateListData;
        },
        editedStatus() {
            return this.$store.state.edit.editedStatus;
        }
    },
    data() {
        return {
            parentNode: {'name': 'EditDetail'},
            titleData: {'titleText': '编辑', 'titleCreate': '保存', 'showCancel': false},
        }
    },
    beforeCreate: function() {
        if(!this.$store.state.detail.personInfo.id){
            this.$router.replace('/record');
        }
    },
    mounted: function() {
        var me = this;
        setTimeout(() => {
            me.initDom();
        }, 100);
    },
    methods: {
        initDom() {
            // 重置编辑页内容的高度
            var titleDiv = document.getElementsByClassName('title-bar')[0],
                contentDiv = document.getElementsByClassName('edit-detail-content')[0];
            // if(contentDiv) {
            //     contentDiv.style.paddingTop = titleDiv.clientHeight + 'px';
            // }
            if(CONFIG.platform == 'web') {
                this.$el.style.minHeight = (innerHeight - 52) + 'px';
            }

            // 重置编辑页命盘的样式
            var fateDiv = document.getElementsByClassName('layout-detail-fate')[0];
            fateDiv.className = "layout-detail-fate edit-detail-fate dsp-flex";
        },
        clickShowAreaOverlay() {
            this.$store.state.collate.showArea = false;
        },
        clickShowBirthdayOverlay() {
            this.$store.state.collate.showBirthday = false;
        },
        clickChooseGroup() {
            // 非一级页面要用push的方式
            var params = this.$router.history.current.params.from;
            params = params ? params.replace('_', '/') : 'record'; 
            this.$router.replace('/edit/'+params+'/'+this.$store.state.detail.personInfo.id+'/choosegroup');
        },
        clickChooseLabel() {
            var params = this.$router.history.current.params.from;
            params = params ? params.replace('_', '/') : 'record'; 
            this.$router.replace('/edit/'+params+'/'+this.$store.state.detail.personInfo.id+'/label');
        },
        clickBack() {
            // 二次确认
            var me = this;
            if(this.$store.state.edit.editedStatus){
                this.$dialog.confirm({
                    message: '是否要保存修改？',
                    confirmButtonText: '保存',
                    cancelButtonText: '不保存'
                }).then(() => {
                    // 触发保存
                    me.$store.dispatch('edit/saveEditDetail');
                }).catch(() => {
                    // 返回上一页并重置数据
                    me.backPage();
                    me.$store.dispatch('collate/resetData')
                    me.$store.dispatch('edit/resetData')
                    me.$store.dispatch('group/resetChooseGroupData')
                }); ;

            }else{
                // 返回上一页并重置数据
                me.backPage();
                this.$store.dispatch('collate/resetData')
                this.$store.dispatch('edit/resetData')
            }
        },
        backPage() {
            // 处理跳转页面
            var path = this.$router.history.current.path;
            path = path.replace('edit', 'detail');
            this.$router.replace(path);
        },
        clickSave() {
            if(this.$store.state.edit.editedStatus) {
                this.$store.dispatch('edit/saveEditDetail');
            }else{
                this.$toast("未检测到修改");
            }
        }

    }

}
</script>